import { Domaine } from '../interfaces/domaine.interface'
import { DomaineActionTypes, DomaineActions } from './domaine.action'

interface DomaineState {
    domaines: Domaine[]
}

const initialState: DomaineState = {
    domaines: []
}

const domaineReducer = (state: DomaineState = initialState, action: DomaineActions): DomaineState => {
    switch (action.type) {
        case DomaineActionTypes.SET_DOMAINES:
            return {
                ...state,
                domaines: action.domaines
            }

        case DomaineActionTypes.ADD_DOMAINE:
            return {
                ...state,
                domaines: [...state.domaines, action.domaine]
            }
        default:
            return state
    }
}

export default domaineReducer
